import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IApp } from './../../../stores/AllStores';

// Styles
const s = require('./404.css');

// Component
@inject('store')
@observer
export class PageNotFound extends React.Component<IApp, {}> {
    constructor(props) {
        super(props);
    }

    public render() {
        return (
            <div className={s.container}>
                <div className={s.error}>

                    <h1>Page not allowed</h1>

                </div>
            </div>
        );
    }
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/errors/404-not-found/404.tsx